<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import {FunnelPath} from "@/path";
import Swal from "sweetalert2";
/* Dashboard component */
export default {
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Stock out Import",
      items: [
        {
          text: "Stock Out",
        },
        {
          text: "Import",
          active: true,
        },
      ],
      date : null,
      file : null,
      baseUrl : process.env.VUE_APP_API_BACKEND_URL,
      date_filter : null,
      currentPage : 1,
      reports : [],
      fields: ['report_generated_date','actions']
    };
  },
  watch: {
    currentPage(){
      this.getReports();
    }
  },
  mounted(){
    this.getReports();
  },
  methods : {
    async savePolicy(){
      try {
        // if(this.date == null){
        //     Swal.fire('Please Select Date','','error');
        //     return;
        // }
        let formData = new FormData();
        // formData.append('date',this.date);
        formData.append('file',this.file);
        let res = await axios.post(this.baseUrl + FunnelPath.STOCKOUT_IMPORT,formData,{
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if(res.data.status){
          Swal.fire('success','','success');          
        }
      }catch (err){
        console.log(err);
      }
    },
    async downloadData(date){
      try {
        let res = await axios.get(this.baseUrl + FunnelPath.STOCKOUT_GENERATE,{
          params : {
            date : date
          }
        });
        if(res.data.status){
          window.location.href = res.data.data.link;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getReports(){
      try {
        let res = await axios.get(this.baseUrl + FunnelPath.STOCKOUT_REPORTS,{
          params : {
            date : this.date_filter,
            page: this.currentPage
          }
        });
        if(res.data.status){
           this.reports = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <b-card-body>
        <!-- <b-form-group>
          <label>Date</label>
          <b-datepicker v-model="date"></b-datepicker>
        </b-form-group> -->
        <b-form-group>
          <label>Csv File Upload</label>
          <b-form-file accept=".csv" @change="((e) => file = e.target.files[0])"></b-form-file>
        </b-form-group>
        <b-form-group>
          <b-button variant="success" @click="savePolicy">Submit</b-button>
        </b-form-group>
      </b-card-body>

      <div class="table-responsive mb-0">
              <b-table
                :key="reports.key"
                :items="reports.data"
                :fields="fields"
                responsive="sm"                
                :current-page="currentPage"
              >
                <template v-slot:cell(report_generated_date)="row">
                    {{ row.item.status_updated_at }}
                </template>
                <template v-slot:cell(actions)="row">
                    <b-button variant="success" @click="downloadData(row.item.status_updated_at)" v-if="row.item.download_logs.import_progress == 1">
                      <i class="fa fa-download"></i>
                    </b-button>
                </template>
              </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div
            class="dataTables_paginate paging_simple_numbers float-right"
          >
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                :key="reports.key"
                v-model="currentPage"
                :total-rows="reports.total"
                :per-page="reports.per_page"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-card>
  </Layout>
</template>
